import React from 'react'
import classes from './Topbar.module.css';
import { logo } from '../../../constant';
import clsx from 'clsx';
const Topbar = () => {
    return (
        <div className={classes["topbarMain"]}>
             {/* <img
          src={logo}
          alt="logo"
          className={clsx("img-fluid", classes.logo)}
        /> */}
        </div>
    )
}

export default Topbar